import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcFormHeader]'
})
export class FormHeaderDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
